export const createServiceObject = (service) => {
  let serviceToStore = {}
  serviceToStore.publicId = service.publicId
  serviceToStore.qpId = service.qpId
  if (service.hasOwnProperty('name')) {
    serviceToStore.name = service.name
  } else {
    serviceToStore.name = ''
  }
  if (service.hasOwnProperty('adult')) {
    serviceToStore.adult = service.adult
  } else {
    serviceToStore.adult = 0
  }
  if (service.hasOwnProperty('child')) {
    serviceToStore.child = service.child
  } else {
    serviceToStore.child = 0
  }
  if (service.hasOwnProperty('totalCost')) {
    serviceToStore.totalCost = service.totalCost
  } else {
    serviceToStore.totalCost = 0
  }
  if (service.hasOwnProperty('customLength')) {
    serviceToStore.customLength = service.customLength
  } else {
    serviceToStore.customLength = 0
  }
  return serviceToStore
}
